<div (mouseleave)="leave.emit(true)" class="highlight">
    {{definition?.length > 150 ? definition.slice(0, 150)+'...' : definition }}
    <div *ngIf="definition?.length > 150" class="d-flex justify-content-end">
        <a (click)="leave.emit(true)" [routerLink]="['/modules','glossary', 'view', id]"> {{ loadMoreText }} </a>
    </div>
</div>